// extracted by mini-css-extract-plugin
export var text = "facebook-banner-module--text---Iz6a";
export var wrapper = "facebook-banner-module--wrapper--y4+8o";